import { __ } from "@wordpress/i18n";
import Hint from '../components/Hint/Hint';
import Switch from '../components/Switch/Switch';
import { useMenu } from '../contexts/MenuContext';
import withForm from '../layouts/withForm';
const RecommendationsBasic = ({handleChange}) => {
    const {
        settingData
    } = useMenu();

    return (
        <>
            <div className="setting-unit">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Basic", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("General hardening security policies you can apply to your WooCommerce site.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Disable \"anyone can register\"", "ultimate-security")}</h6>
                                </div>
                            </div>                                    
                            <div className="col-auto">
                                <Switch 
                                    name="security.recommendations.disable_anyone_can_register"
                                    checked={settingData?.security?.recommendations?.disable_anyone_can_register} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Disable the built-in file editors", "ultimate-security")}</h6>
                                </div>
                            </div>                                    
                            <div className="col-auto">
                                <Switch 
                                    name="security.recommendations.disable_file_editors"
                                    checked={settingData?.security?.recommendations?.disable_file_editors} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Prevent specific file types (e.g. .php, .js, .mp4) in 'Uploads' folder", "ultimate-security")}</h6>
                                </div>
                            </div>                                    
                            <div className="col-auto">
                                <Switch 
                                    name="security.recommendations.prevent_code_execution_uploads_folder"
                                    checked={settingData?.security?.recommendations?.prevent_code_execution_uploads_folder} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Hide your WordPress version", "ultimate-security")}</h6>
                                </div>
                            </div>                                    
                            <div className="col-auto">
                                <Switch 
                                    name="security.recommendations.hide_wordpress_version"
                                    checked={settingData?.security?.recommendations?.hide_wordpress_version} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Prevent login feedback", "ultimate-security")}</h6>
                                </div>
                            </div>                                    
                            <div className="col-auto">
                                <Switch 
                                    name="security.recommendations.prevent_login_feedback"
                                    checked={settingData?.security?.recommendations?.prevent_login_feedback} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Disable user enumeration", "ultimate-security")}</h6>
                                </div>
                            </div>                                    
                            <div className="col-auto">
                                <Switch 
                                    name="security.recommendations.disable_user_enumeration"
                                    checked={settingData?.security?.recommendations?.disable_user_enumeration} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Unset X-Powered-By header", "ultimate-security")}</h6>
                                </div>
                            </div>                                    
                            <div className="col-auto">
                                <Switch 
                                    name="security.recommendations.unset_x_powered_by_header"
                                    checked={settingData?.security?.recommendations?.unset_x_powered_by_header} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Block the username 'admin','administrator','superadmin','root','manager'", "ultimate-security")}</h6>
                                </div>
                            </div>                                    
                            <div className="col-auto">
                                <Switch 
                                    name="security.recommendations.block_common_usernames"
                                    checked={settingData?.security?.recommendations?.block_common_usernames} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Prevent the same login and display name on user registration by making them different.", "ultimate-security")}</h6>
                                </div>
                            </div>                                    
                            <div className="col-auto">
                                <Switch 
                                    name="security.recommendations.change_display_name"
                                    checked={settingData?.security?.recommendations?.change_display_name} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Hide Admin Bar From Frontend", "ultimate-security")}</h6>
                                </div>
                            </div>                                    
                            <div className="col-auto">
                                <Switch 
                                    name="security.recommendations.hide_front_admin_bar"
                                    checked={settingData?.security?.recommendations?.hide_front_admin_bar} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Hide Admin Bar From Backend", "ultimate-security")}</h6>
                                </div>
                            </div>                                    
                            <div className="col-auto">
                                <Switch 
                                    name="security.recommendations.hide_back_admin_bar"
                                    checked={settingData?.security?.recommendations?.hide_back_admin_bar} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default withForm(RecommendationsBasic, 'security.recommendations');